<template>
  <component :is="name" :detail="detail" :hasError="hasError" />
</template>

<script>
import BrokenImageLink from '@/components/seo/checkUp/BrokenImageLink';
import BrokenLink from '@/components/seo/checkUp/BrokenLink';
import BrokenScriptLink from '@/components/seo/checkUp/BrokenScriptLink';
import BrokenStylesheetLink from '@/components/seo/checkUp/BrokenStylesheetLink';
import CanonicalCheck from '@/components/seo/checkUp/CanonicalCheck';
import CheckAlt from '@/components/seo/checkUp/CheckAlt';
import CompressedHtml from '@/components/seo/checkUp/CompressedHtml';
import ContentCdn from '@/components/seo/checkUp/ContentCdn';
import CrawlAvoidance from '@/components/seo/checkUp/CrawlAvoidance';
import CssCache from '@/components/seo/checkUp/CssCache';
import CssMinify from '@/components/seo/checkUp/CssMinify';
import DeprecatedHtmlTag from '@/components/seo/checkUp/DeprecatedHtmlTag';
import DirectoryBrowsing from '@/components/seo/checkUp/DirectoryBrowsing';
import Docktype from '@/components/seo/checkUp/Docktype';
import Email from '@/components/seo/checkUp/Email';
import Favicon from '@/components/seo/checkUp/Favicon';
import HasRobot from '@/components/seo/checkUp/HasRobot';
import HasSiteMap from '@/components/seo/checkUp/HasSiteMap';
import Heading from '@/components/seo/checkUp/Heading';
import HtmlSize from '@/components/seo/checkUp/HtmlSize';
import HttpsCheck from '@/components/seo/checkUp/HttpsCheck';
import ImageCache from '@/components/seo/checkUp/ImageCache';
import InlineCss from '@/components/seo/checkUp/InlineCss';
import JsCache from '@/components/seo/checkUp/JsCache';
import JsError from '@/components/seo/checkUp/JsError';
import JsMinify from '@/components/seo/checkUp/JsMinify';
import LinkSns from '@/components/seo/checkUp/LinkSns';
import MediaQuery from '@/components/seo/checkUp/MediaQuery';
import MetaDescription from '@/components/seo/checkUp/MetaDescription';
import MetaTitle from '@/components/seo/checkUp/MetaTitle';
import NestTable from '@/components/seo/checkUp/NestTable';
import NoFollowCheck from '@/components/seo/checkUp/NoFollowCheck';
import NoIndexCheck from '@/components/seo/checkUp/NoIndexCheck';
import NormalizationUrl from '@/components/seo/checkUp/NormalizationUrl';
import OutBoundLink from '@/components/seo/checkUp/OutBoundLink';
import PageCache from '@/components/seo/checkUp/PageCache';
import SafeBrowsing from '@/components/seo/checkUp/SafeBrowsing';
import ServerSignature from '@/components/seo/checkUp/ServerSignature';
import SiteLoadingSpeedDesktop from '@/components/seo/checkUp/SiteLoadingSpeedDesktop';
import SiteLoadingSpeedMobile from '@/components/seo/checkUp/SiteLoadingSpeedMobile';
import SpfRecord from '@/components/seo/checkUp/SpfRecord';
import StructuredData from '@/components/seo/checkUp/StructuredData';
import UrlRedirect from '@/components/seo/checkUp/UrlRedirect';
import UseFlash from '@/components/seo/checkUp/UseFlash';
import UseFrame from '@/components/seo/checkUp/UseFrame';
import UseHttp2 from '@/components/seo/checkUp/UseHttp2';
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  components: {
    BrokenImageLink,
    BrokenLink,
    BrokenScriptLink,
    BrokenStylesheetLink,
    CanonicalCheck,
    CheckAlt,
    CompressedHtml,
    ContentCdn,
    CrawlAvoidance,
    CssCache,
    CssMinify,
    DeprecatedHtmlTag,
    DirectoryBrowsing,
    Docktype,
    Email,
    Favicon,
    HasRobot,
    HasSiteMap,
    Heading,
    HtmlSize,
    HttpsCheck,
    ImageCache,
    InlineCss,
    JsCache,
    JsError,
    JsMinify,
    LinkSns,
    MediaQuery,
    MetaDescription,
    MetaTitle,
    NestTable,
    NoFollowCheck,
    NoIndexCheck,
    NormalizationUrl,
    OutBoundLink,
    PageCache,
    SafeBrowsing,
    ServerSignature,
    SiteLoadingSpeedDesktop,
    SiteLoadingSpeedMobile,
    SpfRecord,
    StructuredData,
    UrlRedirect,
    UseFlash,
    UseFrame,
    UseHttp2
  }
};
</script>
